import { jwtDecode } from 'jwt-decode';
import posthog from 'posthog-js';

const SESSION_IDENTIFIER = 'curr-uat';

export const authenticateUser = (token: string) => {
    localStorage.setItem(SESSION_IDENTIFIER, token);
};

export const isUserAuthenticated = () => {
    let source: 'local' | 'session' | null = null;
    let user: { id: number; iat: number; exp: number } | null = null;
    try {
        const ls = localStorage.getItem(SESSION_IDENTIFIER);
        user = jwtDecode<{ id: number; iat: number; exp: number }>(ls || '');
        source = 'local';
        if (user.exp <= Math.floor(Date.now() / 1000)) {
            localStorage.removeItem(SESSION_IDENTIFIER);
            user = null;
        }
    } catch (_e) {
        localStorage.removeItem(SESSION_IDENTIFIER);
    }
    if (!user) {
        try {
            const ls = sessionStorage.getItem(SESSION_IDENTIFIER);
            user = jwtDecode<{ id: number; iat: number; exp: number }>(ls || '');
            source = 'session';
        } catch (_e) {
            sessionStorage.removeItem(SESSION_IDENTIFIER);
        }
    }
    return { user, source };
};

export const deauthenticateUser = () => {
    posthog.reset();
    localStorage.removeItem(SESSION_IDENTIFIER);
    localStorage.removeItem('show_suspension_banner');
};

export const getToken = () => {
    let token = localStorage.getItem(SESSION_IDENTIFIER);
    if (!token) token = sessionStorage.getItem(SESSION_IDENTIFIER);
    return token;
};

export const getLastAccountId = () => localStorage.getItem('laID');

export const setLastAccountId = (id: string | number) => {
    localStorage.setItem('laID', id.toString());
};

export const setBannerDismiss = (id: string | number) => {
    const banners = localStorage.getItem('banner');
    if (banners) {
        let bannerArray = JSON.parse(banners);
        if (typeof bannerArray === 'number') {
            bannerArray = [bannerArray, Number(id)];
        } else {
            bannerArray.push(Number(id));
        }
        localStorage.setItem('banner', JSON.stringify(bannerArray));
    } else {
        localStorage.setItem('banner', JSON.stringify([Number(id)]));
    }
};

export const checkBannerDismiss = (id: string | number) => {
    let match = false;
    const bannerArrayString = localStorage.getItem('banner');
    if (bannerArrayString) {
        const bannerArray = JSON.parse(bannerArrayString);
        if (typeof bannerArray === 'number' && Number(bannerArray) === Number(id)) {
            match = true;
        } else if (Array.isArray(bannerArray) && bannerArray.includes(Number(id))) {
            match = true;
        }
    }
    return match;
};

export const getDevHost = (readOnly = false) => {
    let host = localStorage.getItem('devHost');
    if (!host && !readOnly) {
        console.log('DEVELOPMENT HOST UNDEFINED, DEFAULTING TO app.current.tech');

        console.log('LOOK IN DEVTOOLS -> APPLICATION -> LOCALSTORAGE -> devHost TO UPDATE');
        host = 'app.current.tech'; // change this to dev on your phone for a different hub
        setDevHost(host);
    }
    return host;
};

export const setDevHost = (host: string) => {
    localStorage.setItem('devHost', host);
};

export const setMicroPaymentsSession = () => {
    localStorage.setItem('temp-sess', Date.now().toString());
};

export const getMicroPaymentsSession = () => {
    const microSess = localStorage.getItem('temp-sess');
    if (!microSess) return false;
    if (Date.now() - Number(microSess) >= 500_000) {
        localStorage.removeItem('temp-sess');
        return false;
    }
    return true;
};

export const deleteMicroPaymentsSession = () => {
    localStorage.removeItem('temp-sess');
};
